import React from 'react';
import { X, CheckCircle2 } from 'lucide-react';
import { useSocialProof } from '../hooks/useSocialProof';
export function SocialProofPopup() {
  const {
    notification,
    isVisible,
    dismiss
  } = useSocialProof();
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-40 max-w-[320px] bg-brand-black border border-brand-gold/30 rounded-lg shadow-2xl p-4 pr-8 animate-slide-up" data-id="element-211">
      <button onClick={dismiss} className="absolute top-2 right-2 text-brand-muted hover:text-brand-text transition-colors" aria-label="Cerrar notificación" data-id="element-212">
        <X size={16} data-id="element-213" />
      </button>

      <div className="flex items-start space-x-3" data-id="element-214">
        <img src={notification.img} alt={notification.name} className="w-10 h-10 rounded-full object-cover border border-brand-gold flex-shrink-0" data-id="element-215" />
        <div className="flex flex-col" data-id="element-216">
          <p className="text-sm text-brand-text leading-tight mb-1" data-id="element-217">
            <span className="font-bold" data-id="element-218">{notification.name}</span> de{' '}
            {notification.city} compró{' '}
            <span className="text-brand-gold font-semibold" data-id="element-219">
              {notification.pack}
            </span>{' '}
            hace {notification.time}
          </p>
          <div className="flex items-center text-brand-green text-xs font-medium" data-id="element-220">
            <CheckCircle2 size={12} className="mr-1" data-id="element-221" />
            Compra verificada
          </div>
        </div>
      </div>
    </div>;
}